// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 368) return "static/chunks/368-46954fbd182b7109.js";
	if (chunkId === 327) return "static/chunks/327-46f171ed5f6ab9e1.js";
	if (chunkId === 80) return "static/chunks/80-2257de40352bcfbd.js";
	if (chunkId === 755) return "static/chunks/755-a7ce24c03aaa35ed.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"197":"6f2c6f63a4b43f12","422":"98e9c4f961e5eb0f","452":"1ee6f6c474825019","522":"d75c2207a411b29f","641":"c50e7a3a809fe55d"}[chunkId] + ".js";
};